import React from 'react'
import ReactDOM from 'react-dom'
import VideoPlayer from './VideoPlayer.jsx'
import { parseDataTags } from '../../../spa/utility/index.js'

customElements.get('video-player') ||
  (function () {
    class VideoPlayerElement extends HTMLElement {
      connectedCallback() {
        const settings = this.dataset?.settings
        const tags = this.dataset?.tags
        const pdfLinks = this.dataset?.pdflinks

        if (settings) {
          const key = 'playlistId:'
          const index = settings.lastIndexOf(key)

          if (index >= 0) {
            const playlistId = settings.substring(
              index + key.length,
              settings.length
            )
            const isInline = settings.indexOf('inline') >= 0
            const dataTags = tags ? parseDataTags(tags) : null
            const reactContainerClass = 'video-player-app'
            const reactContainer = document.createElement('div')

            reactContainer.setAttribute('class', reactContainerClass)

            this.appendChild(reactContainer)

            let autoplay = false

            if (window.location.search) {
              const urlParams = new URLSearchParams(window.location.search)
              const videoid = urlParams ? urlParams.get('video') : ''
              const ids = videoid ? videoid.split('-') : []

              if (ids[1] === playlistId) {
                autoplay = true
              }
            }

            let pdfLinksArray = []
            if (pdfLinks) {
              pdfLinksArray = pdfLinks.split('|')
            }

            ReactDOM.render(
              <VideoPlayer
                playlistId={playlistId}
                isInline={isInline}
                autoplay={autoplay}
                dataTags={dataTags}
                pdfLinks={pdfLinksArray}
              />,
              reactContainer
            )
          }
        }
      }
    }

    customElements.define('video-player', VideoPlayerElement)
  })()
